import { useNavigate, useParams } from "react-router-dom";

import { useCase } from "src/hooks/useCase";
import { Pane } from "src/components/Pane";
import { ScenarioCreatePage } from "./ScenarioCreatePage";
import { ScenarioEditPage } from "./ScenarioEditPage";

interface Props {}

export function ScenarioGeneralSettingsPage(props: Props) {
  const navigate = useNavigate();
  const { caseId = "", scenarioId = ""} = useParams<{ caseId: string; scenarioId: string }>();
  const { data: acase } = useCase(caseId);

  function handleClose() {
    if (!acase) return null;
    navigate(`/cases/${acase.id}`);
  }

  return render();

  function render() {
    if (scenarioId === "new") {
      return (
        <Pane>
          <ScenarioCreatePage onClose={handleClose} />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <ScenarioEditPage key={`${caseId}-${scenarioId}`} onClose={handleClose} />
      </Pane>
    );
  }
}
